export const toFixed = (number: number | undefined, decimals: number): string => {
  if (number === undefined) return String(0);

  const numStr: string = String(number);

  if (numStr.includes('.') || decimals > 0) {
    // eslint-disable-next-line prefer-const
    let [integerPart, decimalPart]: string[] = numStr.split('.');
    decimalPart = decimalPart || '';

    const zerosToAdd: number = decimals - decimalPart.length;
    decimalPart += '0'.repeat(Math.max(0, zerosToAdd));

    return `${integerPart}.${decimalPart}`;
  }

  return numStr;
};
